import { computed } from "@vue/composition-api";
import * as storymapStoreModule from '../../store';



export const hasFocusedRelease = computed(() => {
    const state = storymapStoreModule.useStorymapStore().state;
    return state.releases.some(x => x.isFocused);
});

export const tasksInFocusedRelease = computed(() => {
    const state = storymapStoreModule.useStorymapStore().state;
    const focusedRelease = state.releases.find(x => x.isFocused);

    if (focusedRelease == null) {
        return [];
    }

    const taskIds = state.subtasks.filter(x => x.releaseId == focusedRelease.id).map(x => x.taskId);
    return state.tasks.filter(x => taskIds.includes(x.id));
});

export const activitiesInFocusedRelease = computed(() => {
    const state = storymapStoreModule.useStorymapStore().state;
    const focusedRelease = state.releases.find(x => x.isFocused);

    if (focusedRelease == null) {
        return [];
    }

    const activityIds = state.subtasks.filter(x => x.releaseId == focusedRelease.id).map(x => x.activityId);
    return state.activities.filter(x => activityIds.includes(x.id));
});